export const menu = () => {
  const menuOverlay = document.querySelector(".js-menu-overlay");
  const menuBtn = document.querySelector(".js-header-menu-btn");
  const menu = document.querySelector(".js-menu");
  const links = document.querySelectorAll(".js-menu a");

  // メニューのON/OFFを切り替える関数
  const toggleMenu = () => {
    menuOverlay.classList.toggle("is-active");
    menuBtn.classList.toggle("is-active");
    menu.classList.toggle("is-active");
    document.body.classList.toggle("is-hamburger-menu-open");
  };

  // メニューを閉じる（activeクラスを全削除する）関数
  const closeMenu = () => {
    menuOverlay.classList.remove("is-active");
    menuBtn.classList.remove("is-active");
    menu.classList.remove("is-active");
    document.body.classList.remove("is-hamburger-menu-open");
  };

  menuBtn.addEventListener("click", toggleMenu);
  menuOverlay.addEventListener("click", closeMenu);
  links.forEach((link) => {
    link.addEventListener("click", closeMenu);
  });
};
